<div class="modal-header">
  <h4 uni-heading color="primary" class="modal-title" id="exampleModalScrollableTitle">
    Previzualizar Documento: {{ file.name }}
  </h4>
  <button uni-icon-button variant="muted" aria-label="Cerrar" (click)="closeModal()">
    <uni-icon name="x"></uni-icon>
  </button>
</div>
<div class="modal-body">
  <div class="container">
    <div class="modal-container-spacer">
      <embed src="getFilePreviewURL(file.object)" width="250" height="200" />
    </div>
  </div>
</div>
<div class="modal-footer">
  <button uni-button fill="outline" variant="secondary" (click)="closeModal()">Cancelar</button>
</div>
